import PlayerAvatar from '../assets/player.jpg';

export const soccerData = {
  enfuego: {
    team_name: 'En Fuego CF',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Marcel',
        position: { x: 510, y: 150 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Marcel',
        position: { x: 340, y: 650 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Marcel',
        position: { x: 750, y: 950 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Marcel',
        position: { x: 800, y: 450 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Marcel',
        position: { x: 700, y: 350 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Marcel',
        position: { x: 150, y: 450 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Marcel',
        position: { x: 650, y: 650 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Marcel',
        position: { x: 750, y: 150 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Marcel',
        position: { x: 150, y: 750 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Marcel',
        position: { x: 910, y: 750 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 17,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'Rush Hour',
        date: 'Mon, 5 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: 2,
          highestScorer: 'Ronaldo',
          mostAssists: 'Pique',
          bestDefence: 'Ronaldo',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Hooligans FC',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Real Hustlers',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Avengars',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Amigos',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Thunder',
        date: 'Mon, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },

  rush_hour: {
    team_name: 'Rush Hour',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Ronaldo',
        position: { x: 150, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Ronaldo',
        position: { x: 650, y: 650 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Ronaldo',
        position: { x: 850, y: 550 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Ronaldo',
        position: { x: 200, y: 90 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Ronaldo',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 20,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'En Fuego CF',
        date: 'Mon, 5 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: 2,
          highestScorer: 'Ronaldo',
          mostAssists: 'Pique',
          bestDefence: 'Ronaldo',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Hooligans FC',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Real Hustlers',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Avengars',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Amigos',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Thunder',
        date: 'Mon, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },

  hooligans_FC: {
    team_name: 'Hooligans FC',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 15,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'En Fuego CF',
        date: 'Wed, 7 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Rush Hour',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Real Hustlers',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Avengars',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Amigos',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Thunder',
        date: 'Mon, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },

  real_hustlers: {
    team_name: 'Inter Real Hustlers FC',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 22,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'En Fuego CF',
        date: 'Wed, 7 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Hooligans FC',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Rush Hours',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Avengars',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Amigos',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Thunder',
        date: 'Mon, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },

  avengars: {
    team_name: 'Team Avengers',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 26,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'En Fuego CF',
        date: 'Wed, 7 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Thunder',
        date: 'Mon, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Hooligans FC',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Real Hustlers',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Rush Hour',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Amigos',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },

  amigos: {
    team_name: 'Amigos',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 28,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'En Fuego CF',
        date: 'Wed, 7 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Thunder',
        date: 'Mon, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Hooligans FC',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Real Hustlers',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Avengars',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Rush Hour',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },

  thunder: {
    team_name: 'Thunder',
    team_players: [
      {
        id: 'player-01',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-02',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-03',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-04',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-05',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-06',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-07',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-08',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-09',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-10',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
      {
        id: 'player-11',
        player_name: 'Marcel',
        position: { x: 50, y: 50 },
        apperances: '21',
        avatar: PlayerAvatar,
        goals: '3',
        assists: '5',
        cross_accuracy: '36',
        key_passes: '2',
        tackles: '1.9',
      },
    ],
    team_performance: [
      {
        goals: 9,
        shotspg: 24.6,
        discipline: 8,
        possession: 87.7,
        pass: 90,
        aerialsWon: 12.3,
        rating: 9.1,
      },
    ],
    upcoming_matches: [
      {
        id: 'upcoming-match-01',
        opponent: 'En Fuego CF',
        date: 'Wed, 7 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-02',
        opponent: 'Hooligans FC',
        date: 'Fri, 9 September',
        time: '07:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-03',
        opponent: 'Inter Real Hustlers FC',
        date: 'Sun, 11 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-04',
        opponent: 'Real Hustlers',
        date: 'Tue, 13 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-05',
        opponent: 'Avengars',
        date: 'Thu, 15 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
      {
        id: 'upcoming-match-06',
        opponent: 'Amigos',
        date: 'Sat, 17 September',
        time: '04:00 PM',
        venue: 'Abcvs ayt',
        matchResult: {
          goalKeeperSave: '0',
          highestScorer: '0',
          mostAssists: '0',
          bestDefence: '0',
        },
      },
    ],
  },
};

export const teamData = Object.entries(soccerData).map(([_, value]) => value);
